
























import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';
import { mapState } from "vuex";

import Library from "@/components/Library/Library.vue";
import NodeTree from "@/components/NodeTree/NavPanel.vue";
import Properties from "@/components/Properties.vue";

import flatmap from "@/utils/flatmap";

import Nav from '@/services/Navigation';
import NavNode from "@/services/NavigationNode";

@Component({
	components: {
		Library,
		NodeTree,
		Properties,
	},
	computed: {
		...mapState(["selectedNodeUid"])
	}
})
export default class NavPanel extends Vue {
	@Prop({default: false}) readonly ro!: boolean;
	@PropSync('nav') localNav !: Nav;
	@Prop({ default: () => []}) readonly siteMap !: NavNode[];
	selectedNodeUid!: string;

	get nodeTree() {
		return this.localNav.nodes;
	}

	set nodeTree(newValue: NavNode[]) {
		this.localNav.nodes = newValue;
	}

	get flatmap(): Map<string, NavNode> {
		return flatmap(new Map, this.nodeTree);
	}
	
	get property(): NavNode | undefined {
		return this.selectedNodeUid ? this.flatmap.get(this.selectedNodeUid) : {} as NavNode;
	}
	
	remove(uid: string) {
		this.nodeTree = this.nodeTree.filter((node) => node && node.uid !== uid);
		this.$store.dispatch("unsetSelected");
		// child nodes of a folder are still in flatmap,
		// so nexttick so computed flatmap will clean up
		this.$nextTick();
	}
}
